import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'hashtag',
  templateUrl: './hashtag.component.html',
  styleUrls: ['./hashtag.component.sass']
})
export class HashtagComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
